module.exports = __webpack_public_path__ + "media/roomBgm.9348228a.mp3";